














import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { getElement } from "@/lib/elementHelpers";

export default defineComponent({
  name: "BaseSwitch",
  props: {
    label: { type: String as PropType<string | TranslateResult>, default: "" },
    name: { type: String, default: "" },
    value: { type: Boolean, required: true },
    small: { type: Boolean },
  },
  model: {
    event: "input",
    prop: "value",
  },
  methods: {
    click() {
      (getElement(this.$refs.checkbox) as HTMLInputElement).click();
    },
  },
});
